interface PwaSwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Texto para lectores de pantalla: qué prende o apaga. */
  label: string;
  disabled?: boolean;
}

/** Interruptor accesible (`role="switch"`) de la app mobile. No hay uno en `components/ui`. */
export function PwaSwitch({ checked, onChange, label, disabled = false }: PwaSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 disabled:cursor-not-allowed disabled:opacity-50 ${
        checked ? 'bg-primary' : 'bg-[#D1CCE6]'
      }`}
    >
      <span
        aria-hidden
        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
          checked ? 'translate-x-6' : 'translate-x-1'
        }`}
      />
    </button>
  );
}
